import React from 'react';

const ErrorsPopup = ({ show, message, onClose, showDataInTable }) => {
  const hasExtra = !!showDataInTable;
  return show ? (
    <div className="fixed inset-0 bg-disable z-30 flex justify-center items-center">
      <div className={`p-5 rounded-md bg-white  w-[301px]  max-w-[400px] flex flex-col justify-center items-center ${
        hasExtra ? 'min-h-[190px] gap-3' : 'h-[190px] gap-5 py-5'
      }`}>
        <p className="text-center">{message}</p>
        {hasExtra && showDataInTable()}
        <button
          className="py-2 w-1/4 bg-primary text-white rounded-full p-3"
          onClick={onClose}
        >
          Ok
        </button>
      </div>
    </div>
  ) : null;
};

export default ErrorsPopup;
